export default "__VITE_ASSET__BvdeC8R1__"